import { Button, Form, Modal, Select } from 'antd';
import { useChangeAbsenceResponsibleMutation } from 'app/services/edpApiV1/absence';
import { useSubordinatesQuery } from 'app/services/edpApiV1/viewer';
import React, { useEffect, useState } from 'react';
import { RolesUser } from 'shared/enums';
import { RolesToRussian } from 'shared/enums/rolesUser';
import { getErrorData } from 'shared/helpers/utils';
import { useNotifications } from 'shared/hooks/use-notifications';

type TProps = {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  requestId: number;
  hrIdCurrent?: number;
};

const ModalAbsenceSubordinates = ({ openModal, setOpenModal, requestId, hrIdCurrent }: TProps) => {
  const [form] = Form.useForm();
  const [btnState, setBtnState] = useState<boolean>(true);

  const { data: allSubordinates } = useSubordinatesQuery({ include: 'me' });

  const [changeResponsibleTrigger, resultChangeResponsible] = useChangeAbsenceResponsibleMutation({
    selectFromResult: result => ({ ...result, error: getErrorData(result.error) }),
  });
  const {
    isSuccess: isSuccessChangeResponsible,
    isError: isErrorChangeResponsible,
    error: errorChangeResponsible,
    reset: resetChangeResponsible,
  } = resultChangeResponsible;

  const handleOk = () => {
    setOpenModal(false);
  };

  const handleCancel = () => {
    setOpenModal(false);
    form.resetFields();
    setBtnState(true);
  };

  const onSelect = (hr: number) => {
    setBtnState(false);
    if (hr === hrIdCurrent) setBtnState(true);
  };

  const onFinish = (values: { hrId: number }) => {
    const { hrId } = values;
    const bodyRequest = {
      requestId,
      hrId,
    };
    changeResponsibleTrigger(bodyRequest);
    setOpenModal(false);
    form.resetFields();
    setBtnState(true);
  };

  useEffect(() => {
    if (hrIdCurrent) {
      form.setFieldsValue([{ name: 'hrId', value: hrIdCurrent }]);
    }
  }, [form, hrIdCurrent]);

  useNotifications(
    isSuccessChangeResponsible,
    isErrorChangeResponsible,
    'Ответственный назначен',
    errorChangeResponsible?.message,
    resetChangeResponsible,
  );

  return (
    <Modal
      title="Выберите ответственного сотрудника"
      footer={false}
      onOk={handleOk}
      onCancel={handleCancel}
      visible={openModal}
    >
      <Form form={form} name="changeResponsible" onFinish={onFinish}>
        <Form.Item
          name="hrId"
          rules={[
            {
              validator: async (_, v) => {
                if (v === hrIdCurrent) return Promise.reject();
              },
              message: 'Выберите нового ответственного',
            },
          ]}
        >
          <Select placeholder="Выберите из списка" onSelect={onSelect}>
            {allSubordinates && (
              <>
                {[
                  ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.SecondLine]),
                  ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.FirstLine]),
                  ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.Consultant]),
                  ...allSubordinates.filter(sub => sub.roleName === RolesToRussian[RolesUser.Employee]),
                ].map(({ id, name, middleName, lastName }) => (
                  <Select.Option key={id} value={id}>
                    {`${lastName} ${name} ${middleName ?? ''}`}
                  </Select.Option>
                ))}
              </>
            )}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary" disabled={btnState}>
            Назначить
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAbsenceSubordinates;
